// extracted by mini-css-extract-plugin
export default {"wrapper":"PresensiDigital_wrapper__3FVth","title":"PresensiDigital_title__rkifS","subTitle":"PresensiDigital_subTitle__ipCdc","button":"PresensiDigital_button__f65Oq"};